/* Stack Builder tweaks - moved to a theme asset (Claude, 26 Aug 2026).
   The inline <script> copy in the section is being neutralised for some
   visitors (guest sessions rendered dead grids on all three stores), while
   same-origin asset scripts run fine site-wide. This file restores the
   builder; it is GUARDED to no-op when the inline copy already executed,
   so nothing runs twice. Loaded with defer from sections/stack-builder-overrides.liquid. */
if (document.getElementById('csb-presets')) {
(function(){
  /* real variant ids + per-length prices per chain/metal (EU store, fetched 26 Aug 2026).
     i = variant id, p = sale price, r = RRP. A missing length key means the
     variant does not exist on that product. */
  var CSB_VAR = {
    s: {
      cuban4:{45:{i:49134800175412,p:54.74,r:72.99},50:{i:44880054190388,p:54.74,r:72.99},55:{i:44880054223156,p:54.74,r:72.99},60:{i:44880054255924,p:56.99,r:75.99}},
      cuban6:{45:{i:49134812627252,p:58.49,r:77.99},50:{i:48221899653428,p:58.49,r:77.99},55:{i:48221899686196,p:58.49,r:77.99},60:{i:48221899718964,p:60.74,r:80.99}},
      cuban8:{45:{i:49134819279156,p:62.24,r:82.99},50:{i:44880044982580,p:62.24,r:82.99},55:{i:44880045015348,p:62.24,r:82.99},60:{i:48163360440628,p:64.49,r:85.99}},
      cuban12:{50:{i:44879993733428,p:71.24,r:94.99},55:{i:44879993766196,p:71.24,r:94.99},60:{i:48163375055156,p:73.49,r:97.99}},
      rope3:{45:{i:49134825341236,p:39.74,r:52.99},50:{i:44880030761268,p:39.74,r:52.99},55:{i:44880030794036,p:39.74,r:52.99},60:{i:44880030826804,p:41.99,r:55.99}},
      rope5:{50:{i:44880045375796,p:43.49,r:57.99},55:{i:44880045408564,p:43.49,r:57.99},60:{i:44880045441332,p:45.74,r:60.99}},
      wheat3:{45:{i:49134831272244,p:39.74,r:52.99},50:{i:44880106094900,p:39.74,r:52.99},55:{i:44880106127668,p:39.74,r:52.99},60:{i:44880106160436,p:41.99,r:55.99}},
      wheat5:{50:{i:44880033710388,p:43.49,r:57.99},55:{i:44880033743156,p:43.49,r:57.99},60:{i:44880033775924,p:45.74,r:60.99}},
      figaro3:{50:{i:44880057925940,p:39.74,r:52.99},55:{i:44880057958708,p:39.74,r:52.99},60:{i:44880057991476,p:41.99,r:55.99}},
      figaro5:{50:{i:44880029614388,p:43.49,r:57.99},55:{i:44880029647156,p:43.49,r:57.99},60:{i:44880029679924,p:45.74,r:60.99}},
      connell2:{45:{i:49134806794548,p:39.74,r:52.99},50:{i:44880025649460,p:39.74,r:52.99},55:{i:44880025682228,p:39.74,r:52.99},60:{i:44880025714996,p:41.99,r:55.99}}
    },
    g: {
      cuban4:{45:{i:49134798504244,p:56.24,r:74.99},50:{i:44880047178036,p:56.24,r:74.99},55:{i:44880047210804,p:56.24,r:74.99},60:{i:44880047243572,p:58.49,r:77.99}},
      cuban6:{45:{i:49134812594484,p:59.99,r:79.99},50:{i:48221899424052,p:59.99,r:79.99},55:{i:48221899456820,p:59.99,r:79.99},60:{i:48221899489588,p:62.24,r:82.99}},
      cuban8:{45:{i:49134812660020,p:63.74,r:84.99},50:{i:44880105898292,p:63.74,r:84.99},55:{i:44880105931060,p:63.74,r:84.99},60:{i:48163356574004,p:65.99,r:87.99}},
      cuban12:{50:{i:44880011657524,p:73.49,r:97.99},55:{i:44880011690292,p:73.49,r:97.99},60:{i:48163369156916,p:74.99,r:99.99}},
      rope3:{45:{i:49134819541300,p:41.24,r:54.99},50:{i:44880029876532,p:41.24,r:54.99},55:{i:44880029909300,p:41.24,r:54.99},60:{i:44880029942068,p:43.49,r:57.99}},
      rope5:{50:{i:44880031351092,p:44.99,r:59.99},55:{i:44880031383860,p:44.99,r:59.99},60:{i:44880031416628,p:47.24,r:62.99}},
      wheat3:{45:{i:49134825472308,p:41.24,r:54.99},50:{i:44880106848564,p:41.24,r:54.99},55:{i:44880106881332,p:41.24,r:54.99},60:{i:44880106914100,p:43.49,r:57.99}},
      wheat5:{50:{i:44880042164532,p:44.99,r:59.99},55:{i:44880042197300,p:44.99,r:59.99},60:{i:44880042230068,p:47.24,r:62.99}},
      figaro3:{50:{i:44880056647988,p:41.24,r:54.99},55:{i:44880056680756,p:41.24,r:54.99},60:{i:44880056713524,p:43.49,r:57.99}},
      figaro5:{50:{i:44880052715828,p:44.99,r:59.99},55:{i:44880052748596,p:44.99,r:59.99},60:{i:44880052781364,p:47.24,r:62.99}},
      connell2:{45:{i:49134800929076,p:41.24,r:54.99},50:{i:44880025420084,p:41.24,r:54.99},55:{i:44880025452852,p:41.24,r:54.99},60:{i:44880025485620,p:43.49,r:57.99}}
    }
  };

  /* one image-map correction over the main section's copy */
  STACK_IMG.g['wheat3|figaro5'] = '3mm-wheat-chain-50-5mm-figaro-chain-55-set-gold-ecom-1_31d857ff-dd64-47a0-9372-3d0e99cb64c5.jpg?v=1761045678';

  /* live availability map rendered by Liquid into #csb-stock. Fails OPEN:
     a variant missing from the map is treated as in stock, so a collection
     hiccup can never block purchases. */
  var CSB_STOCK = {};
  try { CSB_STOCK = JSON.parse(document.getElementById('csb-stock').getAttribute('data-stock')) || {}; } catch(e){}
  /* 1 = available, 2 = out of stock, 0 = not made in this length */
  function csbOk(metal, id, len){
    var e = (CSB_VAR[metal][id]||{})[len];
    if (!e) return 0;
    var vid = (typeof e === 'object') ? e.i : e;
    return CSB_STOCK[vid] === 0 ? 2 : 1;
  }

  /* set-level discount rate baked into displayed prices. 0 = none (chain
     Stack & Save deactivated 26 Aug 2026). */
  var CSB_STACK_RATE = 0;
  function csbNet(p){ return Math.round(p * (1 - CSB_STACK_RATE) * 100) / 100; }

  /* price lookup at a given length, falling back to the chain's base price */
  function csbAt(metal, id, len){
    var e = (CSB_VAR[metal][id]||{})[len];
    if (e) return {p:e.p, r:e.r};
    var c = csbById(id);
    return {p:c.price, r:c.rrp};
  }

  CSB_MAXSAVE = (function(){
    var m = 0;
    ['s','g'].forEach(function(mt){
      CSB_CHAINS.forEach(function(x){ CSB_CHAINS.forEach(function(y){
        CSB_LENGTHS.forEach(function(l){
          var L1 = l.id.slice(0,2), L2 = l.id.slice(2);
          var a = csbAt(mt, x.id, +L1), b = csbAt(mt, y.id, +L2);
          var s = (a.r - csbNet(a.p)) + (b.r - csbNet(b.p));
          if (s > m) m = s;
        });
      });});
    });
    return Math.floor(m);
  })();

  /* cheapest-first picker order; Connell leads */
  var CSB_ORDER = ['connell2','rope3','wheat3','figaro3','rope5','wheat5','figaro5','cuban4','cuban6','cuban8','cuban12'];
  CSB_CHAINS.sort(function(a,b){ return CSB_ORDER.indexOf(a.id) - CSB_ORDER.indexOf(b.id); });

  /* default stack = cheapest (Connell + Connell); deep links override */
  csbState.c1 = 'connell2';
  csbState.c2 = 'connell2';
  try {
    var q = new URLSearchParams(location.search);
    if (q.get('metal')==='g' || q.get('metal')==='gold') csbState.metal='g';
    if (q.get('c1') && csbById(q.get('c1'))) csbState.c1 = q.get('c1');
    if (q.get('c2') && csbById(q.get('c2'))) csbState.c2 = q.get('c2');
    if (q.get('len') && CSB_LENGTHS.some(function(l){return l.id===q.get('len')})) csbState.length = q.get('len');
  } catch(e){}

  /* if the opening pick is unavailable at the current length, open on the
     first available (cheapest) chain instead; deep-linked picks are left
     alone so shared links show their true state */
  (function(){
    var q2 = null;
    try { q2 = new URLSearchParams(location.search); } catch(e){}
    var L0 = csbLens();
    [['c1', L0[0]], ['c2', L0[1]]].forEach(function(sl){
      if (q2 && q2.get(sl[0])) return;
      if (csbOk(csbState.metal, csbState[sl[0]], sl[1]) === 1) return;
      var alt = CSB_CHAINS.filter(function(c){ return csbOk(csbState.metal, c.id, sl[1]) === 1; })[0];
      if (alt) csbState[sl[0]] = alt.id;
    });
  })();

  function csbLens(){ return [csbState.length.slice(0,2), csbState.length.slice(2)]; }
  function csbVars(){
    var L = csbLens();
    var a = (CSB_VAR[csbState.metal][csbState.c1]||{})[+L[0]];
    var b = (CSB_VAR[csbState.metal][csbState.c2]||{})[+L[1]];
    return [ a && a.i, b && b.i ];
  }
  function csbAtcButtons(){ return document.querySelectorAll('#csb-root .csb-cta, #csb-root .csb-mobilebar button'); }
  function csbSetAtc(text, disabled){
    csbAtcButtons().forEach(function(b){ b.textContent = text; b.disabled = !!disabled; });
  }

  window.csbATC = function(){
    var v = csbVars();
    if (!v[0] || !v[1]) return;
    var a=csbById(csbState.c1), b=csbById(csbState.c2), L=csbLens();
    var key = a.name+' + '+b.name+' ('+(csbState.metal==='s'?'Silver':'Gold')+', '+L[0]+'+'+L[1]+'cm)';
    csbSetAtc('Adding…', true);
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[
        {id:v[0], quantity:1, properties:{'Stack':key}},
        {id:v[1], quantity:1, properties:{'Stack':key}}
      ]})
    }).then(function(r){
      if (!r.ok) throw new Error('add failed');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      var d = document.getElementById('cart-drawer');
      if (d) {
        setTimeout(function(){ d.setAttribute('open',''); csbSync(); }, 700);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function(){
      csbSetAtc('Out of stock — try another combo', false);
      setTimeout(function(){ csbSync(); }, 2500);
    });
  };

  function csbSync(){
    var L = csbLens();
    var s1 = csbOk(csbState.metal, csbState.c1, L[0]);
    var s2 = csbOk(csbState.metal, csbState.c2, L[1]);
    if (!s1 || !s2) { csbSetAtc('Unavailable in this length — try 50 + 55cm', true); }
    else if (s1 === 2 || s2 === 2) { csbSetAtc('Out of stock in this length — pick another chain', true); }
    else { csbSetAtc('Add stack to bag', false); }
  }

  /* 1. remove the Proven Stack step */
  var _pr = document.getElementById('csb-presets');
  if (_pr) { var _st = _pr.closest('.csb-step'); if (_st) _st.remove(); }

  /* 2. swipe arrows on the two chain pickers (mobile) */
  ['grid1','grid2'].forEach(function(gid){
    var g = document.getElementById(gid);
    if (!g) return;
    var head = g.closest('.csb-step').querySelector('.csb-stephead');
    var nav = document.createElement('span');
    nav.className = 'csb-swipenav';
    nav.innerHTML = '<button type="button" aria-label="Scroll back" onclick="document.getElementById(\''+gid+'\').scrollBy({left:-264,behavior:\'smooth\'})">&lsaquo;</button>'+
                    '<button type="button" aria-label="Scroll forward" onclick="document.getElementById(\''+gid+'\').scrollBy({left:264,behavior:\'smooth\'})">&rsaquo;</button>';
    head.appendChild(nav);
  });

  /* 3. saving chip inside the sticky bar */
  var _mbp = document.querySelector('.csb-mobilebar .p');
  if (_mbp) {
    var row = document.createElement('div');
    while (_mbp.firstChild) row.appendChild(_mbp.firstChild);
    _mbp.appendChild(row);
    var sv = document.createElement('span');
    sv.className = 'csb-mb-save'; sv.id = 'mb-save';
    _mbp.appendChild(sv);
  }

  /* 4. stack thumbnail in the buy box - tap to jump back to the big preview */
  var _bb = document.getElementById('csb-buybox');
  if (_bb) {
    var bbTop = document.createElement('div'); bbTop.className = 'csb-bb-top';
    var th = document.createElement('div'); th.className = 'csb-bb-thumb';
    th.innerHTML = '<img id="bb-thumb" alt="Your stack"><span>See your stack</span>';
    th.onclick = function(){ document.querySelector('.csb-stage').scrollIntoView({behavior:'smooth', block:'center'}); };
    var info = document.createElement('div'); info.className = 'csb-bb-info';
    info.appendChild(_bb.querySelector('.csb-bb-head'));
    info.appendChild(_bb.querySelector('.csb-bb-title'));
    info.appendChild(_bb.querySelector('.csb-bb-price'));
    bbTop.appendChild(th); bbTop.appendChild(info);
    _bb.insertBefore(bbTop, _bb.firstChild);
  }

  /* 4b. length chip overlaid on the stack preview */
  var _shot = document.querySelector('#csb-root .csb-shot');
  if (_shot && !document.getElementById('csb-lenchip')) {
    var _lc = document.createElement('span');
    _lc.id = 'csb-lenchip';
    _shot.appendChild(_lc);
  }

  /* 5. relabel the saving row + What's included under both ATCs */
  var _ssRow = document.getElementById('stackSave');
  if (_ssRow) {
    var lbl = _ssRow.parentElement.querySelector('.n');
    if (lbl) lbl.textContent = 'Total saving vs RRP';
  }
  document.querySelectorAll('#csb-root .csb-sbody .csb-cta, #csb-root .csb-buybox .csb-cta').forEach(function(btn){
    var inc = document.createElement('div');
    inc.className = 'csb-inc';
    inc.innerHTML = '<b>What’s included</b><ul class="csb-inc-list"></ul>';
    btn.insertAdjacentElement('afterend', inc);
  });

  /* 6. wire every ATC button to the real cart */
  csbAtcButtons().forEach(function(b){ b.onclick = window.csbATC; });

  /* 6c. re-dispatch pickers through the overridable global render (the asset
     copy of the main script is block-scoped, so its internal csbRender
     reference would otherwise bypass the override below) */
  window.csbSetMetal = function(m){ csbState.metal=m; window.csbRender(); };
  window.csbSetLength = function(id){ csbState.length=id; window.csbRender(); };
  window.csbPick = function(slot,id){ if(slot===1){ csbState.c1=id; } else { csbState.c2=id; } window.csbRender(); };
  window.csbPreset = function(a,b){ csbState.c1=a; csbState.c2=b; window.csbRender(); window.scrollTo({top:0,behavior:'smooth'}); };

  /* 7. per-length card prices: slot 1 prices at the first length, slot 2 at the second */
  csbChainCard = function(c,slot,selected){
    var L = csbLens();
    var len = +(slot===1 ? L[0] : L[1]);
    var px = csbAt(csbState.metal, c.id, len);
    var st = csbOk(csbState.metal, c.id, len);
    var csbBadge = st===1 ? (c.top ? '<span class="csb-badge">Best seller</span>' : (c.top2 && slot===2 ? '<span class="csb-badge csb-red">Top pick</span>' : ''))
      : '<span class="csb-badge csb-oosbadge">'+(st===0?'Not in this length':'Out of stock')+'</span>';
    return '<div class="csb-card'+(selected?' on':'')+(st===1?'':(st===2?' csb-oos':' csb-oos csb-na'))+'"'+(st===1?' onclick="csbPick('+slot+',\''+c.id+'\')"':'')+'>'+csbBadge+
      '<span class="csb-tick">&#10003;</span><img loading="lazy" src="'+CSB_CDN+c.img[csbState.metal]+'" alt="'+c.name+'">'+
      '<div class="csb-cbody"><div class="csb-cname">'+c.name+'</div>'+
      '<div class="csb-cprice">'+csbGbp(csbNet(px.p))+'<s>'+csbGbp(px.r)+'</s>'+'</div></div></div>';
  };

  /* 8. charged-price framing, computed per metal + length + rerender covering the new elements (replaces main csbRender) */
  window.csbRender = function(){
    document.getElementById('mSilver').className = csbState.metal==='s'?'on':'';
    document.getElementById('mGold').className = csbState.metal==='g'?'on':'';
    document.getElementById('csb-lengths').innerHTML = CSB_LENGTHS.map(function(l){
      return '<div class="csb-lencard'+(csbState.length===l.id?' on':'')+'" onclick="csbSetLength(\''+l.id+'\')">'+
        (l.popular?'<span class="csb-badge">Most popular</span>':'')+'<b>'+l.label+'</b><span>'+l.note+'</span></div>';
    }).join('');
    document.getElementById('grid1').innerHTML = CSB_CHAINS.map(function(c){return csbChainCard(c,1,csbState.c1===c.id)}).join('');
    document.getElementById('grid2').innerHTML = CSB_CHAINS.map(function(c){return csbChainCard(c,2,csbState.c2===c.id)}).join('');

    var a=csbById(csbState.c1), b=csbById(csbState.c2);
    var len=CSB_LENGTHS.find(function(l){return l.id===csbState.length});
    var lens=len.label.replace('cm','').split(' + ');
    var pa=csbAt(csbState.metal, csbState.c1, +lens[0]), pb=csbAt(csbState.metal, csbState.c2, +lens[1]);
    var n1=csbNet(pa.p), n2=csbNet(pb.p);
    var total=Math.round((n1+n2)*100)/100, rrpTot=Math.round((pa.r+pb.r)*100)/100, save=Math.round((rrpTot-total)*100)/100;
    var metal = csbState.metal==='s'?'Silver':'Gold';
    var saveTxt = 'Save '+csbGbp(save);

    document.querySelector('.csb-savebar').innerHTML = 'Save up to <b>€'+CSB_MAXSAVE+'</b> off RRP on your stack';
    document.getElementById('stackimg').src = CSB_CDN + csbStackImg(csbState.c1, csbState.c2);
    var th2 = document.getElementById('bb-thumb');
    if (th2) th2.src = CSB_CDN + csbStackImg(csbState.c1, csbState.c2);
    document.getElementById('stackcap').textContent = a.name+' + '+b.name;
    var _lc2 = document.getElementById('csb-lenchip');
    if (_lc2) _lc2.textContent = lens[0]+' + '+lens[1]+'cm';
    document.getElementById('n1l').textContent = a.name+' ('+metal+') · '+lens[0]+'cm';
    document.getElementById('n2l').textContent = b.name+' ('+metal+') · '+lens[1]+'cm';
    document.getElementById('p1').innerHTML = csbGbp(n1)+' <s style="color:var(--mid)">'+csbGbp(pa.r)+'</s>';
    document.getElementById('p2').innerHTML = csbGbp(n2)+' <s style="color:var(--mid)">'+csbGbp(pb.r)+'</s>';
    document.getElementById('stackSave').textContent = '−'+csbGbp(save);
    document.getElementById('csb-rrp').textContent = csbGbp(rrpTot);
    document.getElementById('total').textContent = csbGbp(total);
    document.getElementById('chip').textContent = saveTxt;
    document.getElementById('mrrp').textContent = csbGbp(rrpTot);
    document.getElementById('mtotal').textContent = ' '+csbGbp(total);
    var mbs = document.getElementById('mb-save');
    if (mbs) mbs.textContent = saveTxt;
    document.getElementById('bb-title').textContent = a.name+' + '+b.name+' ('+metal+') · '+lens[0]+' + '+lens[1]+'cm';
    document.getElementById('bb-rrp').textContent = csbGbp(rrpTot);
    document.getElementById('bb-total').textContent = csbGbp(total);
    document.getElementById('bb-chip').textContent = saveTxt;
    document.querySelectorAll('.csb-inc-list').forEach(function(ul){
      ul.innerHTML = '<li>'+a.name+' ('+metal+') chain · '+lens[0]+'cm</li>'+
        '<li>'+b.name+' ('+metal+') chain · '+lens[1]+'cm</li>'+
        '<li>CRAFTD gift packaging</li>'+
        '<li>Lifetime Guarantee on both chains</li>';
    });
    csbSync();
  };
  csbRender();
})();
}
